import moment from "moment";

//기업상태 파서하는 기능
export const getAge = (value: any) => {
  const birthDate = moment(value, "YYYY-MM-DD");

  // 현재 나이 계산
  const age = moment().diff(birthDate, "years");
  return age;
};
